import React from "react";
import { bannerOuter, bannerBarStyle, bannerRow, logoBox, logoGroup, logoInnerGroup } from "../styles/BannerStyles";
import UserMenu from "./UserMenu";

interface BannerBarProps {
  user: string;
}

const BannerBar: React.FC<BannerBarProps> = ({ user }) => (
  <div style={bannerOuter}>
    <div style={bannerBarStyle}>
      <div style={bannerRow}>
        <div style={logoGroup}>
          <div style={logoInnerGroup}>
            <div style={logoBox}>
              <img
                src={"/assets/Group.png"}
                alt="Edible Arrangements Logo"
                style={{
                  width: "100%", height: "100%", objectFit: "contain"
                }}
              />
            </div>
          </div>
        </div>
        <UserMenu user={user} />
      </div>
    </div>
  </div>
);

export default BannerBar;
